import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaSearch } from 'react-icons/fa';

const NotFoundPage = () => {
  return (
    <div className="container py-5 text-center">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="mb-4">
            <h1 className="display-1 fw-bold text-primary">404</h1>
            <h2 className="mb-3">页面未找到</h2>
            <p className="text-muted mb-4">
              抱歉，您访问的页面不存在或已被移除。请检查您输入的网址是否正确，或返回首页。
            </p>
            
            <div className="d-flex justify-content-center gap-3">
              <Link to="/" className="btn btn-primary px-4">
                <FaHome className="me-2" />
                返回首页
              </Link>
              <Link to="/help" className="btn btn-outline-secondary px-4">
                <FaSearch className="me-2" />
                帮助中心
              </Link>
            </div>
          </div>
          
          {/* 404图示 */}
          <div className="mt-5">
            <svg 
              width="250" 
              height="180" 
              viewBox="0 0 250 180" 
              xmlns="http://www.w3.org/2000/svg"
              className="mb-4"
            >
              <style>
                {`
                  .small { font: italic 13px sans-serif; fill: #3f51b5; }
                  .heavy { font: bold 30px sans-serif; fill: #333; }
                  .eye { fill: #333; }
                  .brows { stroke: #333; stroke-width: 2; }
                  .mouth { stroke: #333; stroke-width: 2; fill: none; }
                `}
              </style>
              <circle cx="125" cy="80" r="60" fill="#f0f0f0" />
              <circle cx="100" cy="70" r="8" className="eye" />
              <circle cx="150" cy="70" r="8" className="eye" />
              <path d="M90 50 Q 100 35 110 50" className="brows" />
              <path d="M140 50 Q 150 35 160 50" className="brows" />
              <path d="M100 110 Q 125 130 150 110" className="mouth" />
              <text x="30" y="160" className="heavy">找不到页面</text>
              <text x="90" y="175" className="small">404 Not Found</text>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage; 